import React from "react";
import DocumentList from "./DocumentList";

const Rutiner: React.FC = () => {
    return <DocumentList documentType="RUTINER" />;
};

export default Rutiner;
